
// @ts-nocheck
import locale__app_locales_en_US_ts from "../locales/en-US.ts?hash=1cb8531a&locale=en";
import locale__app_locales_id_ID_ts from "../locales/id-ID.ts?hash=52189ade&locale=id";


export const localeCodes =  [
  "en",
  "id"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en-US.ts", load: () => Promise.resolve(locale__app_locales_en_US_ts), cache: false }],
  "id": [{ key: "../locales/id-ID.ts", load: () => Promise.resolve(locale__app_locales_id_ID_ts), cache: false }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "language": "en-US",
      "label": "English",
      "files": [
        "/app/locales/en-US.ts"
      ]
    },
    {
      "code": "id",
      "language": "id-ID",
      "label": "Bahasa Indonesia",
      "files": [
        "/app/locales/id-ID.ts"
      ]
    }
  ],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://samurairekrutmen.id",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "label": "English",
    "files": [
      {
        "path": "/app/locales/en-US.ts"
      }
    ]
  },
  {
    "code": "id",
    "language": "id-ID",
    "label": "Bahasa Indonesia",
    "files": [
      {
        "path": "/app/locales/id-ID.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
